import React, {type ReactNode} from 'react';

import {apiTabContent, apiTabContentIncreasePadding} from './tab-content.module.styl';


type Props = {
    increasePadding?: boolean,
    children: ReactNode,
};
export const TabContent = ({increasePadding, children}: Props) => (
    <div className={`${apiTabContent} ${increasePadding ? apiTabContentIncreasePadding : ''}`}>
        {children}
    </div>
);
